import { makeStyles } from '@mui/styles';

const useLoginStyle = makeStyles({
  loginContainer: {
    minHeight: '100vh',
    display: "flex",
    padding: "1rem",              // was 2rem — reduced so card doesn't get squished on mobile
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    boxSizing: "border-box",
  },

  loginPaper: {
    padding: "32px",
    width: "100%",
    maxWidth: "400px",            // was 310px — wider card on desktop, still fits mobile
    boxSizing: "border-box",
    "@media (max-width:480px)": {
      padding: "24px 20px",      // less padding on small phones so fields aren't tiny
    },
  },

  loginTitle: {
    fontWeight: '600 !important',
    textAlign: "center",
    marginBottom: "16px"
  },

  loginSubtext: {
    color: "red",
    textAlign: "center",
    marginBottom: "8px"
  },

  loginButton: {
    background: '#4565B7 !important',
    textTransform: "none !important",
    padding: '1rem !important',
    fontSize: '1rem !important',
    fontWeight: '600 !important'
  },

  versionText: {
    position: "absolute !important",
    bottom: "10px !important",
    right: "10px !important",
    fontSize: "0.75rem !important",
    color: "#9E9E9E !important",
  },
});

export default useLoginStyle;
